export default __webpack_public_path__ + "static/media/avatar.c1f1ef27.jpg";